import Vue from 'vue';
import moment from '@/plugins/moment';
import { typeToIcon as taxonomyTypeToIcon } from '@/modules/taxonomy/config';
import { $t } from '@/utils';
import { i18n } from '@/plugins/vue-i18n';

export function capitalize(value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function uncapitalize(value) {
  if (!value) return '';
  value = value.toString();
  return value.charAt(0).toLowerCase() + value.slice(1);
}

export function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

Vue.filter('translate', (value) => {
  const translations = [
    value,
    `message.${value}`,
    `message.common.${value}`,
  ];
  const translation = translations.find(t => i18n.te(t));
  if (translation) {
    return i18n.tc(translation, 1);
  }
  return value;
});

Vue.filter('formatDate', (value, format = 'DD/MM/YYYY - HH:mm') => {
  if (!value) return '';
  if (isNumeric(value)) return value;
  value = value.toString();
  const date = moment(value);
  if (!date.isValid()) return value;
  const invalidValueRegex = new RegExp('^[a-zA-Z]+', 'i');
  if (invalidValueRegex.test(value)) return value;
  return date.format(format);
});

// Returns translated value
Vue.filter('formatTrueFalse', value => $t(value ? 'message.common.yes' : 'message.common.no'));

Vue.filter('formatDateFromNow', (value, format = 'DD/MM/YYYY - HH:mm') => {
  const mNow = moment();
  const mDate = moment(value);
  if (mNow.diff(mDate, 'days') > 1
  || mNow.diff(mDate, 'days') < 1) {
    return mDate.format(format);
  }
  return capitalize(mDate.fromNow());
});

Vue.filter('trunc', (value, limit = 60) => {
  if (!value) return '';
  value = value.toString().trim();
  if (value.length < limit) return value;
  return `${value
    .trim()
    .substring(0, limit)
    .trim()}…`;
});

Vue.filter('capitalize', capitalize);

Vue.filter('uncapitalize', uncapitalize);

Vue.filter('highlight', (value, highlight = '', wrapTag = 'strong') => {
  if (typeof value !== 'string') return '';
  return value.replace(new RegExp(`(${highlight})`, 'i'), `<${wrapTag}>$1</${wrapTag}>`);
});

Vue.filter('taxonomyIcon', value => taxonomyTypeToIcon(value));
